import { HttpClient } from './serviceBase';
import { utils } from '../utils/utils'

class BankAccountsService {
    Search = async (filters) => {
        const queryString = utils.GetQueryStringsFromObject({ ...filters })
        return await HttpClient.Get(`/api/cashRegisters/bankAccounts?${queryString}`);
    }
}

export default new BankAccountsService();